'use strict';

// @TODO update newsletter logic to match the one from newsletter.js script (used for all newsletter subscription forms)

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    offwhiteInit();
});

function offwhiteInit() {
    // standard form validation (formPrepare.js, validationLogic.js, ...) can not be used here
    // so the form status and error message are managed directly through jQuery validator
    var $form = $('.keep-me-informed-form');

    if ($form.length) {
        var $formfieldset = $form.find('.gl_form-group'),
            $email = $form.find('.email'),
            $errorMessage = $form.find('.gl_error-message'),
            validator = $form.validate(),
            options = {};

        $email.rules('add', {
            required: true,
            email: true
        });

        $email.on('keyup input', window.vbqUtils._debounce(function () {
            if ($(this).val() !== '') {
                validator.element(this);
            }
        }, 200));

        // put back the form in pristine state (input with no value, no error)
        validator.resetForm();
        $formfieldset.removeClass('gl_has-error');

        //handle submit form logic for footer newsletter form
        $form.on('submit', function (e) {
            e.preventDefault();

            var $thisForm = $(this);

            if (!$thisForm.valid()) {
                return false;
            }

            var $thisFieldset = $thisForm.find('.gl_form-group'),
                $thisSubmitButton = $thisForm.find('.form-submit'),
                $thisEmail = $thisForm.find('.email'),
                email = $thisEmail.val(),
                source = $thisEmail.data('source'),
                optin = $thisForm.find('.optin').prop('checked');

            //send email to server
            $.ajax({
                method: 'POST',
                url: window.Urls.subscribeToNewsletter,
                data: {
                    email: email,
                    source: source,
                    optinconsent: optin
                },
                cache: false,
                beforeSend: function () {
                    options = {};
                    window.vbqUtils.progress.show($thisSubmitButton);
                    $thisSubmitButton.attr('disabled', 'disabled');
                    $thisFieldset.removeClass('gl_has-success gl_has-error');
                }
            }).done(function (data) {
                // GDPR-33 - GDPR - Revision of consents
                if (!data.error && data.type == 'success') {
                    $thisForm.find('.gl_form-group').addClass('gl_has-success');
                    $('.js-keepMeInformedForm').addClass('hidden');
                    $('.js-keepMeInformedSuccess').removeClass('hidden');
                }
                // GDPR-26 - GDPR - Footer Modal - New consent modal
                else if (!data.error && data.type == 'consents') {
                    $.ajax({
                        method: 'POST',
                        url: window.Urls.consentForNewsletterSubscription,
                        data: {
                            email: email,
                            source: source,
                            optinconsent: optin
                        },
                        cache: false,
                        beforeSend: function () {
                            options = {};
                        }
                    }).done(function (data) {
                        window.vbqUtils.progress.hide();

                        if (!data.alert && data.type == 'success') {
                            $thisFieldset.addClass('gl_has-success');
                            $('.js-keepMeInformedForm').addClass('hidden');
                            $('.js-keepMeInformedSuccess').removeClass('hidden');
                        }
                        else {
                            options[$thisEmail.attr('name')] = window.Resources.VALIDATE_EMAIL_GLOBAL;
                            validator.showErrors(options);
                            $thisSubmitButton.removeAttr('disabled');
                        }
                    }).fail(function () {
                        window.vbqUtils.progress.hide();
                        options[$thisEmail.attr('name')] = window.Resources.SERVER_ERROR;
                        validator.showErrors(options);
                        $thisSubmitButton.removeAttr('disabled');
                    });
                }
                else {
                    $thisFieldset.removeClass('gl_loading');
                    switch (data.type) {
                        case 'format':
                            options[$thisEmail.attr('name')] = window.Resources.VALIDATE_EMAIL;
                            break;
                        case 'already':
                            options[$thisEmail.attr('name')] = window.Resources.VALIDATE_EMAIL_ALREADY;
                            break;
                        default:
                            options[$thisEmail.attr('name')] = window.Resources.VALIDATE_EMAIL_GLOBAL;
                            break;
                    }
                    validator.showErrors(options);
                    $thisSubmitButton.removeAttr('disabled');
                }
            }).fail(function () {
                $thisFieldset.removeClass('gl_loading');
                options[$thisEmail.attr('name')] = window.Resources.SERVER_ERROR;
                validator.showErrors(options);
                $thisSubmitButton.removeAttr('disabled');
            });
        });
    }
}
